<template>
  <div class="pagina-validacao">
    <div class="container-validacao">
      <h1 class="titulo-pagina">Verificar certificados</h1>

      <div class="painel-validacao">
        <!-- BUSCA -->
        <div class="area-busca">
          <div class="form-validacao">
            <label for="codigo" class="label-codigo">
              Código de Validação
            </label>

            <div class="controles-busca">
              <input
                id="codigo"
                v-model.trim="codigo"
                type="text"
                class="form-control input-codigo"
                placeholder="Digite o código"
                maxlength="14"
                autocomplete="off"
                @keyup.enter="validar"
              />

              <button
                type="button"
                class="btn-verificar"
                :disabled="loading || !codigo"
                @click="validar"
              >
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                ></span>

                {{ loading ? 'Verificando...' : 'Verificar' }}
              </button>
            </div>
          </div>
        </div>

        <!-- ERRO -->
        <div v-if="erro" class="alerta-erro">
          <span class="icone-erro">×</span>
          <span>{{ erro }}</span>
        </div>

        <!-- RESULTADO -->
        <div v-if="certificado" class="area-resultado">
          <div class="alerta-sucesso">
            <span class="icone-sucesso">
              <i class="icofont-check"></i>
            </span>

            <span>Certificado Autêntico e Válido</span>
          </div>

          <!-- CARD DETALHES -->
          <div class="card-detalhes">
            <div class="card-detalhes-header">
              <div>
                <h2>Detalhes do Documento</h2>
                <p>Informações registradas na emissão.</p>
              </div>

              <button type="button" class="btn-pdf" @click="verCertificado">
                <i class="icofont-file-pdf"></i>
                Visualizar PDF
              </button>
            </div>

            <!-- CERTIFICADO INDIVIDUAL -->
            <div v-if="certificadoIndividual" class="lista-detalhes">
              <div class="linha-detalhe">
                <div class="label-detalhe">Nome completo</div>
                <div class="valor-detalhe valor-destaque">
                  {{ certificado.nome_participante }}
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Certificado</div>

                <div class="valor-detalhe">
                  {{ certificado.titulo }}

                  <span v-if="certificado.subtitulo" class="subvalor">
                    {{ certificado.subtitulo }}
                  </span>
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Data da atividade</div>
                <div class="valor-detalhe">
                  {{ formatarData(certificado.inicio) }}
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Carga horária</div>
                <div class="valor-detalhe">
                  {{ formatarHoras(certificado.qtd_horas) }} horas
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Modalidade</div>
                <div class="valor-detalhe">
                  {{ certificado.meio }}
                </div>
              </div>

              <div v-if="certificado.facilitador" class="linha-detalhe">
                <div class="label-detalhe">Facilitador(a)</div>
                <div class="valor-detalhe">
                  {{ certificado.facilitador }}
                </div>
              </div>

              <div class="linha-detalhe linha-codigo">
                <div class="label-detalhe">Código de Validação</div>
                <div class="valor-detalhe codigo-validacao">
                  {{ certificado.codigo_certificado }}
                </div>
              </div>
            </div>

            <!-- CERTIFICADO GERAL -->
            <div v-else-if="certificadoGeral" class="lista-detalhes">
              <div class="linha-detalhe">
                <div class="label-detalhe">Nome completo</div>
                <div class="valor-detalhe valor-destaque">
                  {{ certificado.nome_participante }}
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Certificado</div>

                <div class="valor-detalhe">
                  {{ certificado.titulo }}

                  <span v-if="certificado.subtitulo" class="subvalor">
                    {{ certificado.subtitulo }}
                  </span>
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Carga horária total</div>
                <div class="valor-detalhe">
                  {{ formatarHoras(certificado.horas_acumuladas) }} horas
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Última atividade</div>
                <div class="valor-detalhe">
                  {{ formatarData(certificado.ultima_atividade) }}
                </div>
              </div>

              <div class="linha-detalhe">
                <div class="label-detalhe">Data de emissão</div>
                <div class="valor-detalhe">
                  {{ formatarData(certificado.created_at) }}
                </div>
              </div>

              <div class="linha-detalhe linha-codigo">
                <div class="label-detalhe">Código de Validação</div>
                <div class="valor-detalhe codigo-validacao">
                  {{ certificado.codigo_certificado }}
                </div>
              </div>
            </div>
          </div>

          <!-- HISTÓRICO -->
          <div
            v-if="
              certificadoGeral &&
              certificado.participacoes &&
              certificado.participacoes.length
            "
            class="historico"
          >
            <h2 class="titulo-historico">Histórico de Atividades</h2>

            <div class="tabela-container">
              <table class="tabela-participacoes">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Atividade</th>
                    <th>C. Horária</th>
                    <th>Modalidade</th>
                    <th>Facilitador(a)</th>
                    <th>Código</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(participacao, index) in certificado.participacoes"
                    :key="`${participacao.id_participante_oficina}-${index}`"
                  >
                    <td>
                      {{ formatarData(participacao.data_inicio) }}
                    </td>

                    <td>
                      <span class="nome-atividade">
                        {{ participacao.titulo }}
                      </span>

                      <span
                        v-if="participacao.subtitulo"
                        class="subtitulo-atividade"
                      >
                        {{ participacao.subtitulo }}
                      </span>
                    </td>

                    <td>{{ formatarHoras(participacao.carga_horaria) }}h</td>

                    <td>
                      {{ participacao.modalidade || '-' }}
                    </td>

                    <td>
                      {{ participacao.facilitador || '-' }}
                    </td>

                    <td class="codigo-participacao">
                      {{ participacao.codigo_certificado }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidarCertificado',

  data() {
    return {
      codigo: '',
      certificado: null,
      loading: false,
      erro: null,
    }
  },

  computed: {
    certificadoGeral() {
      return this.certificado && this.certificado.tipo_certificado === 'geral'
    },

    certificadoIndividual() {
      return (
        this.certificado && this.certificado.tipo_certificado === 'participacao'
      )
    },
  },

  mounted() {
    const codigo = this.$route.params.codigo

    if (codigo) {
      this.codigo = String(codigo).trim().toUpperCase()

      this.validar()
    }
  },

  methods: {
    /**
     * Valida o certificado informado.
     *
     * @return {Promise<void>}
     */
    async validar() {
      this.erro = null
      this.certificado = null

      const codigo = String(this.codigo || '')
        .trim()
        .toUpperCase()

      if (!codigo) {
        this.erro = 'Informe o código do certificado.'
        return
      }

      this.codigo = codigo
      this.loading = true

      try {
        const response = await this.$api.get(
          `/certificados/${encodeURIComponent(codigo)}`
        )

        if (
          response.data &&
          response.data.error === false &&
          response.data.data
        ) {
          this.certificado = response.data.data
          return
        }

        this.erro = 'Certificado não encontrado.'
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.erro = 'Certificado não encontrado.'
        } else if (error.response && error.response.status === 400) {
          this.erro =
            error.response.data?.message || 'Código do certificado inválido.'
        } else {
          this.erro = 'Não foi possível verificar o certificado.'
        }
      } finally {
        this.loading = false
      }
    },

    /**
     * Formata uma data para o padrão brasileiro.
     *
     * @param {string|null} data
     * @return {string}
     */
    formatarData(data) {
      if (!data) {
        return '-'
      }

      const partes = String(data).substring(0, 10).split('-')

      if (partes.length !== 3) {
        return data
      }

      return `${partes[2]}/${partes[1]}/${partes[0]}`
    },

    /**
     * Abre o certificado para visualização.
     *
     * @return {void}
     */
    verCertificado() {
      if (!this.certificado?.codigo_certificado) {
        return
      }

      const codigo = encodeURIComponent(this.certificado.codigo_certificado)

      window.open(
        `${this.$api.defaults.baseURL}/certificados/${codigo}/pdf`,
        '_blank'
      )
    },

    /**
     * Formata a carga horária removendo casas decimais desnecessárias.
     *
     * @param {number|string|null} horas
     * @return {number|string}
     */
    formatarHoras(horas) {
      if (horas === null || horas === undefined || horas === '') {
        return '-'
      }

      const valor = Number(horas)

      if (Number.isNaN(valor)) {
        return horas
      }

      return Number.isInteger(valor)
        ? valor
        : valor.toLocaleString('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
    },
  },
}
</script>

<style lang="scss" scoped>
$background: #f9fafb;
$white: #fff;
$text: #111827;
$text-secondary: #374151;
$muted: #6b7280;
$muted-light: #9ca3af;
$border: #e5e7eb;

$blue: #1d4ed8;
$blue-hover: #1e40af;

$green: #16a34a;
$green-bg: #f0fdf4;
$green-border: #bbf7d0;
$green-text: #166534;

$red-bg: #fef2f2;
$red-border: #ef4444;
$red-text: #b91c1c;

.pagina-validacao {
  min-height: 100vh;
  padding: 40px 24px;
  background: $background;
  color: $text;

  .container-validacao {
    width: 100%;
    max-width: 896px;
    margin: 0 auto;
  }

  .titulo-pagina {
    margin: 0 0 24px;
    font-size: 30px;
    line-height: 1.2;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: $text;
  }

  .painel-validacao {
    overflow: hidden;
    background: $white;
    border: 1px solid #eef0f3;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 18px rgba(15, 23, 42, 0.05);
  }

  /* BUSCA */

  .area-busca {
    padding: 24px;
    background: $white;
    border-bottom: 1px solid $border;

    .form-validacao {
      display: grid;
      grid-template-columns: 190px minmax(0, 1fr);
      gap: 18px;
      align-items: center;
    }

    .label-codigo {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: $text-secondary;
    }

    .controles-busca {
      display: flex;
      gap: 12px;
      min-width: 0;
    }

    .input-codigo {
      width: 100%;
      min-width: 0;
      height: 42px;
      padding: 0 14px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 15px;
      color: $text;
      text-transform: uppercase;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.14);
      }
    }

    .btn-verificar {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      height: 42px;
      padding: 0 18px;
      border: 0;
      border-radius: 8px;
      background: $blue;
      color: $white;
      font-size: 14px;
      font-weight: 700;
      white-space: nowrap;
      cursor: pointer;
      box-shadow: 0 1px 2px rgba(29, 78, 216, 0.2);
      transition: background 0.2s ease;

      &:hover:not(:disabled) {
        background: $blue-hover;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  /* ERRO */

  .alerta-erro {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 16px;
    background: $red-bg;
    border-left: 4px solid $red-border;
    color: $red-text;
    font-size: 14px;

    .icone-erro {
      font-size: 18px;
    }
  }

  /* RESULTADO */

  .area-resultado {
    padding: 24px;
    background: $background;

    .alerta-sucesso {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 24px;
      padding: 15px 16px;
      border: 1px solid $green-border;
      border-radius: 8px;
      background: $green-bg;
      color: $green-text;
      font-size: 14px;
      font-weight: 700;

      .icone-sucesso {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: $green;
        color: $white;
        font-size: 13px;
      }
    }
  }

  /* CARD DETALHES */

  .card-detalhes {
    overflow: hidden;
    margin-bottom: 30px;
    background: $white;
    border: 1px solid $border;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .card-detalhes-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      padding: 20px 24px;

      h2 {
        margin: 0;
        font-size: 18px;
        line-height: 1.4;
        font-weight: 700;
        color: $text;
      }

      p {
        margin: 4px 0 0;
        color: $muted;
        font-size: 14px;
      }
    }

    .btn-pdf {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      height: 38px;
      padding: 0 14px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      background: $white;
      color: $text-secondary;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      cursor: pointer;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

      &:hover {
        background: $background;
      }
    }

    .lista-detalhes {
      border-top: 1px solid $border;

      .linha-detalhe {
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 16px;
        padding: 16px 24px;
        border-top: 1px solid $border;

        &:first-child {
          border-top: 0;
        }

        &.linha-codigo {
          background: $background;
        }

        .label-detalhe {
          font-size: 14px;
          font-weight: 600;
          color: $muted;
        }

        .valor-detalhe {
          min-width: 0;
          font-size: 14px;
          color: $text;

          &.valor-destaque {
            font-weight: 700;
          }

          &.codigo-validacao {
            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
              monospace;
            font-weight: 800;
            letter-spacing: 0.08em;
          }

          .subvalor {
            display: block;
            margin-top: 4px;
            color: $muted-light;
            font-size: 12px;
          }
        }
      }
    }
  }

  /* HISTÓRICO */

  .historico {
    .titulo-historico {
      margin: 0 0 14px;
      font-size: 18px;
      font-weight: 700;
      color: $text;
    }

    .tabela-container {
      overflow-x: auto;
      background: $white;
      border: 1px solid $border;
      border-radius: 10px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    }

    .tabela-participacoes {
      width: 100%;
      min-width: 760px;
      margin: 0;
      border-collapse: collapse;

      thead {
        background: $background;
      }

      th,
      td {
        padding: 14px 18px;
        border-bottom: 1px solid $border;
        text-align: left;
        vertical-align: middle;
      }

      th {
        color: $muted;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        white-space: nowrap;
      }

      td {
        color: #4b5563;
        font-size: 14px;
      }

      tbody {
        tr {
          &:last-child td {
            border-bottom: 0;
          }

          &:hover {
            background: $background;
          }
        }
      }

      .nome-atividade {
        display: block;
        color: $text;
        font-weight: 600;
      }

      .subtitulo-atividade {
        display: block;
        margin-top: 4px;
        color: $muted-light;
        font-size: 12px;
      }

      .codigo-participacao {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
          monospace;
        white-space: nowrap;
      }
    }
  }

  /* RESPONSIVO */

  @media (max-width: 700px) {
    padding: 24px 14px;

    .titulo-pagina {
      font-size: 25px;
    }

    .area-busca {
      padding: 18px;

      .form-validacao {
        grid-template-columns: 1fr;
        gap: 10px;
      }

      .controles-busca {
        flex-direction: column;
      }

      .btn-verificar {
        width: 100%;
      }
    }

    .area-resultado {
      padding: 16px;
    }

    .card-detalhes {
      .card-detalhes-header {
        align-items: flex-start;
        flex-direction: column;
      }

      .btn-pdf {
        width: 100%;
      }

      .lista-detalhes {
        .linha-detalhe {
          grid-template-columns: 1fr;
          gap: 6px;
        }
      }
    }
  }
}
</style>
